import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

interface IPortal {
  children: React.ReactNode;
  active?: boolean;
}

export const Portal: React.FC<IPortal> = ({ children, active }) => {
  const elRef = useRef<HTMLDivElement | null>(null);
  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  useEffect(() => {
    if (!active) {
      return;
    }

    const portal = document.getElementById("portal-root");
    if (!portal || !elRef.current) {
      return;
    }

    portal.appendChild(elRef.current);
    return () => {
      if (elRef.current) {
        portal.removeChild(elRef.current);
      }
    };
  }, [active]); // Dependencies array is empty because it only needs to run once

  if (!elRef.current) {
    return null;
  }

  return createPortal(children, elRef.current);
};
